import React, { Component } from "react";
import { Row, Col, Button, Modal, Image } from "react-bootstrap";
import "../Common/Common.css";
import PDFViewer from 'pdf-viewer-reactjs';
import { appConfig } from "./../../config";

class CreditNotesimage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const ImgData = this.props.ImageData ? this.props.ImageData : null;
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.handleClose}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{width:"100%",height:"100vh"}}
      >
        <Modal.Header
            style={{
              fontSize: "35px",
              backgroundColor: "#1768B7",
              color: "white"
            }}
            closeButton
          ></Modal.Header>
        <Modal.Body>
        {ImgData !== null ? (
            <PDFViewer
              document={{
                url: appConfig.ip+`/attachments/preview/${encodeURIComponent(ImgData.data)}`,
              }}
              hideRotation={true}
              navigation={{
                css:{
                  navbarWrapper:"navBarClass",
                  zoomOutBtn:"zoomOutClass",
                  zoomInBtn:"zoomInClass"
                }
              }}
            />
          ) : null}
        </Modal.Body>
      </Modal>
    );
  }
}

export default CreditNotesimage;